import { PlusIcon } from "icons/outline";
import { useEffect, useMemo, useState } from "react";
import { Button } from "ui";
import { useRouter } from "next/router";
import Layout from "../../components/Layout";
import { AvailableProvidersModal } from "../../features/providers/components/AvailableProvidersModal";
import {
  customColumns,
  customConnectionHeadings,
  customConnectionRender,
} from "../../features/providers/components/tableUtils";
import Table from "../../components/Table";
import { usePlatformConnect } from "../../contexts/PlatformConnectProvider";
import { getCarriedQueryParams } from "../../utils/urlParamsAndFilters";

export default function ConnectionsPage() {
  const [showAvailableProvidersModal, setShowAvailableProvidersModal] =
    useState(false);
  const { isPlatformConnectMode } = usePlatformConnect();
  const router = useRouter();
  const {
    query: { type },
  } = router;

  useEffect(() => {
    if (type === "available") setShowAvailableProvidersModal(true);
  }, [type]);

  const addConnection = () => {
    setShowAvailableProvidersModal(true);

    router.replace({
      query: { ...router.query, type: "available" },
    });
  };

  const columns = useMemo(
    () =>
      isPlatformConnectMode
        ? customColumns.filter((column) => column !== "accounts")
        : customColumns,
    [isPlatformConnectMode]
  );

  return (
    <Layout metaTitle="Connections">
      <div className="w-full">
        <Table
          hideGlobalSearch={isPlatformConnectMode}
          tableTitle="Connections"
          tableDescription="Browse our directory of connections, and integrate your favorite providers anywhere in MEA."
          onAddItemClick={addConnection}
          url="/d/providers/connected/"
          tableName="connection"
          getRowId={(row) => row?.id}
          customHeadings={customConnectionHeadings}
          customRender={customConnectionRender}
          customColumns={columns}
          addItemContent={
            <Button onClick={addConnection}>
              <span>Add new connection</span>
              <PlusIcon className="shrink-0" />
            </Button>
          }
          emptyMessage="Get started by connecting a new provider."
          getPreviewPath={(row) => {
            const searchParams = new URLSearchParams({
              ...getCarriedQueryParams(router.query),
              type: "connected",
            }).toString();
            return `/connections/${row.id}/integration?${searchParams}`;
          }}
          enableRowClickNavigation
          onEditItemClick={(rowId) =>
            router.push({
              pathname: `/connections/${rowId}/integration`,
              query: {
                ...getCarriedQueryParams(router.query),
                type: "connected",
              },
            })
          }
        />

        {showAvailableProvidersModal && (
          <AvailableProvidersModal
            showModal={showAvailableProvidersModal}
            setShowModal={setShowAvailableProvidersModal}
          />
        )}
      </div>
    </Layout>
  );
}

ConnectionsPage.parentPath = "/connections";
